export const ROUTE_ONBOARDING_MAIN_NAME = "onboarding-main-route";
export const ROUTE_WELCOME_NAME = "welcome-route";
export const ROUTE_CONGRATS_NAME = "congrats-route";
export const ROUTE_COMPLETED_INVITE_NAME = "completed-invite-route";
export const ROUTE_ONBOARDING_NAME = "onboarding-route";
export const ROUTE_ONBOARDING_COMPANY_NAME = "onboarding-company-route";
export const ROUTE_ONBOARDING_TELEMATICS_NAME = "onboarding-telematics-route";
export const ROUTE_ONBOARDING_SUMMARY_NAME = "onboarding-summary-route";
